import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const AddNewProject = lazy(() => import('../../container/investor/projects/new'));
const ViewMyProjects = lazy(() => import('../../container/investor/projects/view'));
const ProjectUpdate = lazy(() => import('../../container/borrower/project/projectUpdate'));
const AllProjectsList = lazy(() => import('../../container/investor/projects/AllProjectsList'));
const ProjectDetails = lazy(() => import('../../container/borrower/project/projectDetail/projectDetails'));
const ProjectDetails2 = lazy(() => import('../../container/investor/projects/ProjectDetails'));
const InvestorMilestoneDetails = lazy(() => import('../../container/investor/projects/InvestorMilestoneDetails'));

const projects = () => {
  return (
    <Routes>
      <Route path="view" element={<ViewMyProjects />} />
      <Route path="new" element={<AddNewProject />} />
      <Route path="detail/:id" element={<ProjectDetails />} />
      <Route path="update/:id" element={<ProjectUpdate />} />
      <Route path="all" element={<AllProjectsList />} />
      <Route path="all/:id" element={<ProjectDetails2 />} />
      <Route path="milestones/:id" element={<InvestorMilestoneDetails />} />
    </Routes>
  );
};

export default projects;
